export interface ComponentUnit {
    id: number;
    code: string;
    description: string;
}

export interface ComponentUnitPayload {
    code: string;
    description: string;
}